/* eslint-disable no-alert */
import ApiManager from '../api/crud-manager';
import enableFormSubmit from '../utils/forms/enable-form-submit';
import prepareApiPatchBody from '../utils/array/prepare-api-patch-body';
import fireToastEvent from '../utils/fire-toastr-message';
import reduceFormData from '../utils/array/reduce-form-data';

class AddressesHandler {
  constructor() {
    this.config = {
      addAddressModules: () => document.querySelectorAll('[data-module*="AddAddress"]'),
      editAddressModules: () => document.querySelectorAll('[data-module*="EditAddress"]'),
      deleteAddressModules: () => document.querySelectorAll('[data-module*="DeleteAddress"]'),
      apiAlertModule: () => document.querySelector('[data-module="ApiAlert"]'),
      apiManager: new ApiManager()
    };
  }

  addAddressHandler(_addAddress) {
    const { apiManager, apiAlertModule } = this.config;

    const addAddress = _addAddress;
    const { redirectUrl, initialized } = addAddress.dataset;

    if (initialized) return;
    addAddress.dataset.initialized = true;

    enableFormSubmit(addAddress);
    $(addAddress).parsley();

    addAddress.addEventListener('submit', e => {
      e.preventDefault();

      const postData = reduceFormData(addAddress);

      apiManager
        .post('/api/v1/person/addresses', postData)
        .then(res => {
          if (res.succeeded && redirectUrl) {
            window.location.href = redirectUrl;
          } else {
            const apiModule = apiAlertModule();
            if (apiModule) {
              apiModule.classList.remove('hidden');
              apiModule.innerHTML = addAddress.getAttribute('data-toaster-address-added-error');
            }
          }
        })
        .catch(() => {
          const apiModule = apiAlertModule();
          if (apiModule) {
            apiModule.classList.remove('hidden');
            apiModule.innerHTML = addAddress.getAttribute('data-toaster-address-added-error');
          }
        });
    });
  }

  editAddressHandler(_editAddress) {
    const { apiManager, apiAlertModule } = this.config;

    const editAddress = _editAddress;
    const { redirectUrl, initialized, addressId } = editAddress.dataset;

    if (initialized) return;
    editAddress.dataset.initialized = true;

    enableFormSubmit(editAddress);
    $(editAddress).parsley();

    editAddress.addEventListener('submit', e => {
      e.preventDefault();

      const postData = prepareApiPatchBody(editAddress);
      apiManager
        .patch(`/api/v1/person/addresses/${addressId}`, postData)
        .then(res => {
          if (res.succeeded && redirectUrl) {
            window.location.href = redirectUrl;
          } else {
            const apiModule = apiAlertModule();
            if (apiModule) {
              apiModule.classList.remove('hidden');
              apiModule.innerHTML = editAddress.getAttribute('data-toaster-address-added-error');
            }
          }
        })
        .catch(() => {
          const apiModule = apiAlertModule();
          if (apiModule) {
            apiModule.classList.remove('hidden');
            apiModule.innerHTML = editAddress.getAttribute('data-toaster-address-edit-error');
          }
        });
    });
  }

  deleteAddressHandler(_deleteAddress) {
    const { apiManager } = this.config;
    const deleteAddress = _deleteAddress;
    const { addressId, initialized } = deleteAddress.dataset;

    if (initialized) return;
    deleteAddress.dataset.initialized = true;

    deleteAddress.addEventListener('click', e => {
      e.preventDefault();
      if (!window.confirm(deleteAddress.getAttribute('data-toaster-address-delete-confirm')))
        return;

      apiManager
        .delete(`/api/v1/person/addresses/${addressId}`)
        .then(res => {
          if (!res.succeeded) return;

          const addressBlocks = document.querySelectorAll(`[data-address="${addressId}"]`);

          addressBlocks.forEach(addressBlock => {
            addressBlock.remove();
          });

          fireToastEvent('success', deleteAddress.getAttribute('data-toaster-address-deleted'));
        })
        .catch(() => {
          fireToastEvent('error', deleteAddress.getAttribute('data-toaster-address-delete-error'));
        });
    });
  }

  init() {
    const { addAddressModules, editAddressModules, deleteAddressModules } = this.config;

    addAddressModules().forEach(addAddress => this.addAddressHandler(addAddress));

    editAddressModules().forEach(editAddress => this.editAddressHandler(editAddress));

    deleteAddressModules().forEach(deleteAddress => this.deleteAddressHandler(deleteAddress));
  }
}

export default AddressesHandler;
